import { render } from "./PlacementSegments.vue?vue&type=template&id=2ad6e46b&scoped=true"
import script from "./PlacementSegments.vue?vue&type=script&lang=js"
export * from "./PlacementSegments.vue?vue&type=script&lang=js"

import "./PlacementSegments.vue?vue&type=style&index=0&id=2ad6e46b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad6e46b"]])

export default __exports__